import { makeStyles, Grid, darken } from "@material-ui/core";
import React from "react";
import { useIcons } from "../../../hooks/useIcons";
import DashboardTitle from "./DashboardTitle";

const useStyles = makeStyles((theme) => ({
  item: {
    backgroundColor: ({ isSelected }) =>
      isSelected ? darken("#00B9E1", 0.85) : "#23263F",
    padding: "0px 16px",
    borderRadius: 8,
    border: ({ isSelected }) => isSelected && `1px solid ${"#00B9E1"}`,
    minHeight: 40,
    flexDirection:'row'
  },
  percent: {
    display: "grid",
    justifyItems: "end",
  },
}));

const DashboardListItem = ({ text, icon, percent, isSelected, className }) => {
  const classes = useStyles({ isSelected });
  const Icon = useIcons(icon ?? "");
  return (
    <Grid
      container
      item
      className={`${classes.item} ${className}`}
    >
      <Grid
        container
        item
        xs
      >
        <DashboardTitle
          variant={isSelected ? "dark.accent" : "grey3"}
          fontWeight={500}
          fontSize={17}
          text={text}
        />
        {icon && (
          <Icon
            fontSize="large"
            style={{
              color: isSelected ? "#00B9E1" : "#CAD5E8",
              margin: "auto",
              marginRight: 0,
            }}
          />
        )}
      </Grid>
      <Grid
        container
        item
        xs
        className={classes.percent}
      >
        <DashboardTitle
          variant="grey3"
          fontWeight={isSelected ? 600 : 500}
          fontSize={isSelected ? 24 : 17}
          text={`${percent}`}
        />
      </Grid>
    </Grid>
  );
};

export default DashboardListItem;
